import {TableProps} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import {useTableSearchParams} from "./UseTableSearchParams";
import {CategoryDTO} from "../types/category/CategoryDTO";
import {useGetCategoriesQuery} from "../store/api/CategoryApi";
import {selectQueryFromParams} from "../utils/ConvertQueryParams";
import {Filter} from "../types/utils/Filter";

type UseGetCategoriesType = () => {
    categories: any
    onChangeTable: TableProps<CategoryDTO>["onChange"]
    loading: boolean,
    filter: Filter
    total: number | undefined
}

export const useGetCategories: UseGetCategoriesType = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const {filter} = useTableSearchParams()
    const {data, isFetching} = useGetCategoriesQuery({
        page: filter.page,
        size: filter.size
    })

    const onChangeTable: TableProps<CategoryDTO>["onChange"] = (pagination) => {
        navigate({
            search: selectQueryFromParams(pagination, filter, location.search)
        })
    }

    return {
        categories: data?.data?.content,
        onChangeTable,
        loading: isFetching,
        filter,
        total: data?.data?.total_elements
    }
}